import DistrictInfo from './DistrictInfo.page';

export default DistrictInfo;